import { useTranslation } from 'react-i18next';

import { Card } from 'components';
import { PsButtonTuner } from 'stencilSetup';
import { IntegrationDataDto } from 'theSource/queries';

type MarketPlaceCardProps = {
  integration: IntegrationDataDto;
  isSubscriber?: boolean;
  isTestEmployee?: boolean;
  handleModalPopup: ({
    carrierName,
    bodyText,
    note,
  }: {
    carrierName: string;
    bodyText: string;
    note: string;
  }) => void;
  redirectToPartner: ({
    carrierLookupCode,
    ssoProtocol,
  }: {
    carrierLookupCode: string;
    ssoProtocol: string;
  }) => void;
};

export function MarketPlaceCard({
  integration,
  handleModalPopup,
  redirectToPartner,
  isSubscriber,
  isTestEmployee,
}: MarketPlaceCardProps) {

  const { t } = useTranslation("pages.home");

  return (
    <Card additionalClasses="h-100">
      <div
        id="header"
        className="row d-flex justify-content-center justify-content-lg-between align-bottom w-100 pb-3 border-bottom"
      >
        <div className='d-flex col-12 col-lg-6 justify-content-center justify-content-lg-start p-0 mb-3 mb-lg-0'>
          <img
            src={`data:image/png;base64, ${integration.app_icon}`}
            alt={`member-portal-logo-${integration.carrier_lookup_code}`}
            style={{ maxHeight: '36px' }}
          />
        </div>

        <div className='d-flex col-12 col-lg-6 justify-content-center justify-content-lg-end p-0'>
          { (isSubscriber || isTestEmployee) && <PsButtonTuner
            label={t("viewPortal")}
            buttonId="view-portal"
            level="secondary"
            onClick={() =>
              redirectToPartner({
                carrierLookupCode: integration.carrier_lookup_code,
                ssoProtocol: integration.sso_protocol,
              })
            }
          /> }
        </div>
      </div>

      <div id="body" className="mt-2">
        <p
          className="body1"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'pre-line',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
          }}
        >
          {integration.name}
        </p>

        <a
          href="/#"
          className="link text-dark"
          data-bs-toggle="modal"
          data-bs-target="#member-portal-modal"
          onClick={() =>
            handleModalPopup({
              carrierName: integration.name,
              bodyText: t(integration.description), 
              note: t(integration.note),
            })
          }
          style={{ fontSize: '14px' }}
        >
          {t('common:learnmore')}
        </a>
      </div>
    </Card>
  );
}
